// extracted by mini-css-extract-plugin
export var underlinedLink = "_sr-0";